export const sortByMul = (field, type) => {
  return (a, b) => {
    if (type === 'desc') {
      return b[field] - a[field]
    } else {
      return a[field] - b[field]
    }
  }
}

export const keepURLParams = (that) => {
  if (that.$route.query.database) {
    return {
      database: that.$route.query.database,
      level: that.$route.query.level
    }
  }
  return {}
}

export const htmlToText = (html) => {
  if (html) {
    return html.replace(/<[^>]+>/g, '')
  } else {
    return ''
  }
}
